import { useState } from 'react';
import * as Yup from 'yup';
import toast from 'react-hot-toast';

import { useLazyGetJobsQuery } from '../../../../../../services/jobsV2';

export const useAppliedJobsFilter = ({ setFilters }) => {
  const [getJobs] = useLazyGetJobsQuery();
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const formSchema = Yup.object().shape({
    jobApplicationsJobs: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.number().required(),
      }),
    ),
  });

  const onSearchChange = async (currentValue) => {
    try {
      const attr = currentValue ? { filters: { q: currentValue } } : { page: 1, perPage: 20, filters: {} };
      const data = await getJobs(attr).unwrap();

      return (
        data?.map((job) => ({
          label: `${job.title} at ${job.organization?.name}`,
          value: Number(job.id),
        })) || []
      );
    } catch (error) {
      toast('Failed to load jobs', {
        icon: 'danger',
        id: 'failed-to-load-jobs',
      });
      return [];
    }
  };

  const onSubmit = ({ jobApplicationsJobs }) => {
    setFilters({ jobApplicationsJobs });
  };

  const onMenuOpen = () => {
    setIsLoading(true);
    onSearchChange('').then((data) => {
      setDefaultOptions(data);
      setIsLoading(false);
    });
  };

  return {
    formSchema,
    defaultOptions,
    isLoading,
    onMenuOpen,
    onSearchChange,
    onSubmit,
  };
};
